<template>
  <div class="render">
    <div class="vacate">
      <el-form-item
        :label-width="itemRender.width"
        :label="itemRender.label"
        :required="itemRender.required ? true : false"
      >
        <div class="vacate-item">
          <span>姓名</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>手机号</span>
          <el-input
            v-model="itemRender.money"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>职位</span>
          <el-input
            v-model="itemRender.category"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>部门</span>
          <el-input
            v-model="itemRender.detail"
            placeholder="请输入(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>主管</span>
          <el-input v-model="itemRender.detail" placeholder="请输入"></el-input>
        </div>
        <div class="vacate-item">
          <span>入职地点</span>
          <el-input v-model="itemRender.value" placeholder="请输入"></el-input>
        </div>
        <div class="vacate-item">
          <span>工作地点</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="itemRender.place ? '请输入(必填)' : '请输入'"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>入职日期</span>
          <el-input v-model="itemRender.value" placeholder="请选择"></el-input>
        </div>
        <div class="vacate-item">
          <span>合同期限</span>
          <el-input v-model="itemRender.value" placeholder="请输入"></el-input>
        </div>
        <div class="vacate-item">
          <span>试用期长度</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="itemRender.probation ? '请输入(必填)' : '请输入'"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>工资</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="itemRender.salary ? '请输入(必填)' : '请输入'"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>奖金</span>
          <el-input v-model="itemRender.value" placeholder="请输入"></el-input>
        </div>
        <div class="vacate-item">
          <span>福利</span>
          <el-input v-model="itemRender.value" placeholder="请输入"></el-input>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  created() {
    this.$set(this.itemRender, "money", "");
    this.$set(this.itemRender, "category", "");
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .el-radio {
    margin-bottom: 12px;
  }
}
.vacate {
  .vacate-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid #dfe2e8;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      width: 100px;
    }
  }
  .vacate-item2 {
    background-color: #f7f9ff;
    display: block;
    text-align: center;
    color: #0089ff;
  }
}
.el-form-item {
  position: relative;
  .phone {
    position: absolute;
    right: 10px;
    top: 0px;
  }
  .phoneNumber {
    display: flex;
    align-items: center;
    border: 1px solid #dfe2e8;
    padding: 0 8px;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      padding-right: 8px;
      border-right: 1px solid #dfe2e8;
    }
  }
  .enclosure {
    display: flex;
    align-items: center;
    color: #999999;
    i {
      color: #5794f6;
      font-size: 18px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
}
.money {
  .div {
    margin-top: 12px;
  }
}
</style>
